import { PureComponent, StrictMode } from "react";
import { Body } from "@App/types";

type BodyListItemProps = {
  body: Body;
  onClick: (body: Body) => void;
};

export class BodyListItem extends PureComponent<BodyListItemProps> {
  render() {
    return (
      <StrictMode>
        <div
          className="w-full gap-3 p-3 border-b border-neutral-100 cursor-pointer"
          onClick={() => this.props.onClick(this.props.body)}
        >
          <div className="text-neutral-700">{this.props.body.name}</div>
        </div>
      </StrictMode>
    );
  }
}
